import * as AchievementIcons from './AchievementExport';

export const badgeIconMapping: { [key: string]: { normal: JSX.Element; blocked: JSX.Element } } = {
  seven: {
    normal: <AchievementIcons.Seven />,
    blocked: <AchievementIcons.SevenBlock />
  },
  Likes100: {
    normal: <AchievementIcons.Likes100 />,
    blocked: <AchievementIcons.Likes100Block />
  },
  bookMark: {
    normal: <AchievementIcons.BookMark />,
    blocked: <AchievementIcons.BookMarkBlock />
  },
  bug: {
    normal: <AchievementIcons.Bug />,
    blocked: <AchievementIcons.BugBlock />
  },
  commentKing: {
    normal: <AchievementIcons.CommentKing />,
    blocked: <AchievementIcons.CommentKingBlock />
  },
  early: {
    normal: <AchievementIcons.Early />,
    blocked: <AchievementIcons.EarlyBlock />
  },
  firstComment: {
    normal: <AchievementIcons.FirstComment />,
    blocked: <AchievementIcons.FirstCommentBlock />
  },
  firstNewProductReivew: {
    normal: <AchievementIcons.FirstNewProductReivew />,
    blocked: <AchievementIcons.FirstNewProductReivewBlock />
  },
  firstRecipe: {
    normal: <AchievementIcons.FirstRecipe />,
    blocked: <AchievementIcons.FirstRecipeBlock />
  },
  goFounded: {
    normal: <AchievementIcons.GoFounded />,
    blocked: <AchievementIcons.GoFoundedBlock />
  },
  goldChair: {
    normal: <AchievementIcons.GoldChair />,
    blocked: <AchievementIcons.GoldChairBlock />
  },
  holic: {
    normal: <AchievementIcons.Holic />,
    blocked: <AchievementIcons.HolicBlock />
  },
  kingStar: {
    normal: <AchievementIcons.KingStar />,
    blocked: <AchievementIcons.KingStarBlock />
  },
  newProductUploader: {
    normal: <AchievementIcons.NewProductUploader />,
    blocked: <AchievementIcons.NewProductUploaderBlock />
  },
  ourEmployee: {
    normal: <AchievementIcons.OurEmployee />,
    blocked: <AchievementIcons.OurEmployeeBlock />
  },
  recipeMania: {
    normal: <AchievementIcons.RecipeMania />,
    blocked: <AchievementIcons.RecipeManiaBlock />
  },
  risingStar: {
    normal: <AchievementIcons.RisingStar />,
    blocked: <AchievementIcons.RisingStarBlock />
  },
  sheriff: {
    normal: <AchievementIcons.Sheriff />,
    blocked: <AchievementIcons.SheriffBlock />
  },
  silverChair: {
    normal: <AchievementIcons.SilverChair />,
    blocked: <AchievementIcons.SilverChairBlock />
  },
  soilChair: {
    normal: <AchievementIcons.SoilChair />,
    blocked: <AchievementIcons.SoilChairBlock />
  }
};
